import React, { useState } from "react";
import OfficeSchemeSidebar from "./OfficeSchemeSidebar";
import OfficeApplications from "./OfficeApplications";
import DesignMaster from "./DesignMaster";
import DistrictEstimateMaster from "./DistrictEstimateMaster";
import RNBVerificationPanel from "./RNBVerificationPanel";
import EngineerProgressPanel from "./EngineerProgressPanel";
import CACertificatePanel from "./CACertificatePanel";
import RegistrarApprovalPanel from "./RegistrarApprovalPanel";
import OfficePaymentAccounts from "./OfficePaymentAccounts";
import OfficeAccountsRegister from "./OfficeAccountsRegister";
import OfficeWorkflowMonitor from "./OfficeWorkflowMonitor";
function Panel({ title }) {
  return (
    <div className="bg-white rounded-2xl shadow p-8">
      <h2 className="text-2xl font-bold text-slate-800">{title}</h2>
      <p className="text-slate-500 mt-2">Module working.</p>
    </div>
  );
}

export default function OfficeSchemeDashboard() {
  const [activeTab, setActiveTab] = useState("applications");

  const titles = {
    applications: "Applications",
    designMaster: "Design Master",
    estimateMaster: "District Estimate Master",
    payments: "Payment & Accounts",
    rnb: "R&B Verification",
    engineer: "Engineer Progress",
    ca: "CA Certificate",
    registrar: "Registrar Approval",
  };

  const renderContent = () => {
    if (activeTab === "applications") return <OfficeApplications />;
    if (activeTab === "designMaster") return <DesignMaster />;
    if (activeTab === "estimateMaster") return <DistrictEstimateMaster />;
    if (activeTab === "payments") return <OfficePaymentAccounts />;
    if (activeTab === "rnb") return <RNBVerificationPanel />;
    if (activeTab === "engineer") return <EngineerProgressPanel />;
    if (activeTab === "ca") return <CACertificatePanel />;
    if (activeTab === "registrar") return <RegistrarApprovalPanel />;
    if (activeTab === "accountsRegister") return <OfficeAccountsRegister />;
    if (activeTab === "workflowMonitor") return <OfficeWorkflowMonitor />;

    return <Panel title={titles[activeTab] || "Dashboard"} />;
  };

  return (
    <div className="flex min-h-screen bg-slate-100">
      <OfficeSchemeSidebar activeTab={activeTab} setActiveTab={setActiveTab} />

      <main className="flex-1 p-6">
        <div className="bg-white rounded-2xl shadow p-5 mb-5">
          <h1 className="text-2xl font-bold text-slate-800">
            Cooperative Office Scheme Dashboard
          </h1>
          <p className="text-sm text-slate-500">Fresh working automation base</p>
        </div>

        {renderContent()}
      </main>
    </div>
  );
}